import CustomLink from "./_components/custom-link";

export default CustomLink;
